// apps/web/app/microgrid/lit/shared/ga.ts
export type GAParams = Record<string, unknown>;

const inFrame = () => typeof window !== 'undefined' && window.top !== window.self;

export function track(event: string, params?: GAParams) {
  try {
    if (inFrame()) {
      window.parent.postMessage({ type: 'al:event', event, params: params || {} }, '*');
    } else if (typeof (window as any).gtag === 'function') {
      (window as any).gtag('event', event, params || {});
    }
  } catch {}
}

export function routePing() {
  try {
    const payload = {
      type: 'al:route',
      path: location.pathname + location.search,
      hash: location.hash || '',
    };
    if (inFrame()) window.parent.postMessage(payload, '*');
    else if (typeof (window as any).gtag === 'function') {
      (window as any).gtag('event', 'page_view', {
        page_location: location.href,
        page_path: payload.path + payload.hash,
        page_title: document.title,
      });
    }
  } catch {}
}

export function setParentHash(hash: string) {
  try {
    if (inFrame()) {
      window.parent.postMessage({ type: 'al:set-hash', hash }, '*');
    } else {
      // standalone: update our own hash so behavior matches
      window.history.pushState(null, '', hash);
      window.dispatchEvent(new HashChangeEvent('hashchange'));
    }
  } catch {}
}

export function sectionViewOnce(el: Element, section: string, threshold = 0.35) {
  let sent = false;
  const io = new IntersectionObserver(
    (entries) => {
      if (sent) return;
      if (entries.some((e) => e.isIntersecting)) {
        sent = true;
        track('section_view', { section });
        io.disconnect();
      }
    },
    { threshold }
  );
  io.observe(el);
  return () => io.disconnect();
}
